import { render, staticRenderFns } from "./GreenTextWithArrow.vue?vue&type=template&id=40fb6d8c&scoped=true"
import script from "./GreenTextWithArrow.vue?vue&type=script&lang=js"
export * from "./GreenTextWithArrow.vue?vue&type=script&lang=js"
import style0 from "./GreenTextWithArrow.vue?vue&type=style&index=0&id=40fb6d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb6d8c",
  null
  
)

export default component.exports